<template lang="pug">
  v-row(align="center" style="height:100%;" no-gutters)
    v-col(
      v-for="(_,i) in 6"
      :key="i"
      style="min-width:0; padding:3px; height:100%;"
      align="center"
      cols="auto" 
    ).px-0
      div(
        :class="small ? 'powerballWinNumberCircleSmall' : 'powerballWinNumberCircle'"
        :style="i === 5 ? { background:'var(--bg-color-power-ball)', color:'white' } : { border: 'solid' }  "
      )
        component(
          :is="small? 'h6' : 'h5'"
        ).fontWinnumber {{ winNumberArray[i] }}
</template>
<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false
    },
    winNumberArray: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style scoped>  
@media only screen and (max-width: 640px) {
.fontWinnumber {
  font-size: 2.5vw;
}

}
.powerballWinNumberCircleSmall {
  position: relative; 
  background: white;
  width: min(6vw,30px);
  height: min(6vw,30px);
  border-radius: 50%; 
}
.powerballWinNumberCircle {
  position: relative; 
  width: min(8vw,46px);
  height: min(8vw,46px);
  background: white;
  border-radius: 50%;
  margin: 0 2px 0 2px;
}
.fontWinnumber {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>